<script>
  export let title = '';
  export let className = '';
  export let href = '';
  export let type = 'button';   
  export let onClick = null; 
</script>

{#if href}
  <a href={href} class={`shrink-0 flex font-normal  min-w-[247px] relative items-center ring-1 light:text-[#5F256C] light:ring-[#5F256C] shadow-gradient-border light:bg-white light:hover:from-transparent light:hover:to-transparent text-white ring-white bg-gradient-to-tl from-[#2C419A]/0 to-[#7357A4]/0 hover:from-[#2C419A] hover:to-[#7357A4] hover:text-white hover:ring-white/60 active:text-white active:bg-white ring-inset pb-0.5 justify-center text-[17px] leading-none text-center px-5 h-10  rounded-full duration-150 hover:shadow-none   ${className}`}>
    {title}
  </a>
{:else}
  <button type={type} on:click={onClick} class={`shrink-0 flex font-normal  min-w-[247px] relative items-center ring-1 light:text-[#5F256C] light:ring-[#5F256C] shadow-gradient-border light:bg-white light:hover:from-transparent light:hover:to-transparent text-white ring-white bg-gradient-to-tl from-[#2C419A]/0 to-[#7357A4]/0 hover:from-[#2C419A] hover:to-[#7357A4] hover:text-white hover:ring-white/60 active:text-white active:bg-white  ring-inset pb-0.5 justify-center text-[17px] leading-none text-center px-5 h-10  rounded-full duration-150 hover:shadow-none   ${className}`}>
    {title}
  </button>
{/if}

